// Etichetele jurnalului de acțiuni (Admin → Jurnal acțiuni). Fără React — ușor de testat.
import { formatLei } from "../api/balanceService";

export const ROLE_LABELS = {
   USER: "Elevi",
   INSTRUCTOR: "Instructori",
   MANAGER: "Manageri",
   PROFESSOR: "Profesori",
   ADMIN: "Administratori",
};

export const ROLE_SINGULAR = {
   USER: "elev",
   INSTRUCTOR: "instructor",
   MANAGER: "manager",
   PROFESSOR: "profesor",
   ADMIN: "admin",
};

export const INSTRUCTOR_TYPE_LABELS = {
   BAZA: "De bază",
   SCHIMB: "De schimb",
   EXAMEN: "Examinator",
   SUPERIOR: "Superior",
};

export const CATEGORY_LABELS = {
   lessons: "Lecții",
   exams: "Examene",
   permissions: "Permisiuni examen",
   "practical-exam": "Examen practic",
   theory: "Teorie",
   auth: "Autentificare",
   balance: "Balanță",
   users: "Utilizatori",
   staff: "Personal",
   groups: "Grupe",
   cars: "Mașini",
   notes: "Notițe",
   chat: "Chat",
   notifications: "Notificări",
   reviews: "Recenzii",
   videos: "Video",
   contracts: "Contracte",
   settings: "Setări",
   audit: "Jurnal",
   other: "Altele",
};

export const RESULT_LABELS = {
   ok: "Reușite",
   error: "Erori",
   denied: "Refuzate (fără drepturi)",
};

const ACTION_LABELS = {
   "auth.login": "S-a autentificat",
   "auth.login.failed": "Autentificare eșuată",
   "auth.register": "Cont nou (înregistrare)",
   "auth.register.failed": "Înregistrare eșuată",
   "auth.requestResetPassword": "A cerut resetarea parolei",
   "auth.resetPassword": "A resetat parola",
   "access.denied": "Acces refuzat (fără drepturi)",
   "reservations.create": "A programat lecții (elev)",
   "reservations.createForUser": "A programat lecții pentru elev",
   "reservations.autoAssign": "Programare cu instructor automat (elev)",
   "reservations.autoAssignForUser": "Programare cu instructor automat",
   "reservations.update": "A modificat lecția",
   "reservations.delete": "A șters lecția",
   "reservations.deleteAllForUser": "A șters toate lecțiile elevului",
   "reservations.confirmReservation": "A confirmat lecția",
   "reservations.unconfirmReservation": "A anulat confirmarea lecției",
   "reservations.cancelReservation": "A anulat lecția",
   "reservations.uncancelReservation": "A revenit asupra anulării",
   "reservations.restoreReservation": "A restabilit lecția",
   "users.create": "A creat un utilizator",
   "users.createGuest": "A creat un oaspete",
   "users.update": "A modificat utilizatorul",
   // acțiunile care nu aveau încă denumire (Jurnal acțiuni, 20.10)
   "calendar.createLesson": "A pus o lecție (calendarul nou)",
   "calendar.moveLesson": "A mutat lecția (calendarul nou)",
   "calendar.saveSlotNote": "A scris o notiță pe celulă",
   "notes.create": "A adăugat o notiță",
   "notes.update": "A modificat notița",
   "notes.remove": "A șters notița",
   "instructor-schedules.saveVersion": "A salvat graficul instructorului",
   "instructor-schedules.deleteVersion": "A șters o versiune a graficului",
   "instructor-schedules.saveException": "A schimbat o zi din grafic",
   "instructor-schedules.deleteException": "A scos o zi schimbată din grafic",
   "instructor-substitutions.create": "A pus o înlocuire de instructor",
   "instructor-substitutions.remove": "A scos înlocuirea de instructor",
   "avatars.setMine": "Și-a pus fotografia",
   "avatars.removeMine": "Și-a scos fotografia",
   "avatars.setFor": "A pus fotografia",
   "avatars.removeFor": "A scos fotografia",
   "call-tasks.check": "A verificat lista „De sunat”",
   "call-tasks.done": "A sunat elevul",
   "message-templates.update": "A schimbat un mesaj automat",
   "message-templates.reset": "A revenit la mesajul automat implicit",
   "districts.update": "A modificat sectoarele",
   "notifications.confirmReservation": "A confirmat lecția de mâine",
   "auth.resetPassword.failed": "Resetarea parolei a eșuat",
   "recommended-videos.sendVideo": "A trimis un video recomandat",
   "instructor-ratings.submitRating": "A evaluat instructorul",
   "chat.postMyMessage": "A scris în chat",
   "chat.postStaffReply": "A răspuns în chat",
   "users.remove": "A șters contul",
   "users.setDesiredInstructor": "A ales instructorul dorit",
   "exams.createStudentPermission": "A dat permisiune la examen",
   "exams.bulkCreateStudentPermissions": "A dat permisiuni la examen (mai mulți elevi)",
   "exams.createExam": "A început examenul teoretic",
   "exams.markExamAsFailed": "Examen marcat ca picat",
   "exams.reactivateStudent": "A reactivat elevul la examen",
   "exams.startPractice": "A început un bilet de practică",
   "exams.startPracticeByCategory": "A început o temă de practică",
   "exams.resetPractice": "A resetat biletul de practică",
   "practical-exam-slots.book": "S-a înscris la examenul practic",
   "practical-exam-slots.bookForStudent": "A înscris elevul la examenul practic",
   "practical-exam-slots.deleteReservation": "A scos elevul de la examenul practic",
   "practical-exam-slots.updateReservationStatus": "A pus rezultatul la examenul practic",
   "instructors.update": "A modificat fișa instructorului",
   "instructors.addBlackouts": "A blocat ore la instructor",
   "instructors.deleteBlackout": "A deblocat ore la instructor",
   "groups.create": "A creat o grupă",
   "groups.update": "A modificat grupa",
   "balance.adjust": "A modificat balanța",
   "instructor-ratings.create": "A lăsat o recenzie",
   "contract.generateContracts": "A generat contractele de înscriere",
};

/** "reservations.update" -> "A modificat lecția"; necunoscutele rămân cum sunt. */
export function actionLabel(action) {
   return ACTION_LABELS[action] || action || "";
}

/** Rezultatul unui rând: reușit / eroare / refuzat, cu codul HTTP. */
export function resultOf(row) {
   if (!row) return { kind: "error", label: "" };
   if (row.statusCode === 403) return { kind: "denied", label: "Refuzat" };
   if (row.success) return { kind: "ok", label: "Reușit" };
   if (row.statusCode === 499) return { kind: "error", label: "Conexiune întreruptă" };
   return { kind: "error", label: `Eroare ${row.statusCode}` };
}

export function personLabel(person, fallbackId) {
   if (!person) return fallbackId ? `#${fallbackId}` : "—";
   const name = person.name || person.email || `#${person.id}`;
   return person.deleted ? `${name} (șters)` : name;
}

const pad = (n) => String(n).padStart(2, "0");

/** Data/ora locală pentru <input type="datetime-local">: "2026-10-13T09:05" */
export function toLocalInput(date) {
   const d = new Date(date);
   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Intervalele rapide, în ora locală a browserului. */
export function presetRange(preset, now = new Date()) {
   const end = new Date(now);
   const start = new Date(now);
   switch (preset) {
      case "1h":
         start.setHours(start.getHours() - 1);
         return { from: start, to: null };
      case "today":
         start.setHours(0, 0, 0, 0);
         return { from: start, to: null };
      case "yesterday": {
         start.setDate(start.getDate() - 1);
         start.setHours(0, 0, 0, 0);
         end.setHours(0, 0, 0, 0);
         return { from: start, to: new Date(end.getTime() - 1) };
      }
      case "7d":
         start.setDate(start.getDate() - 7);
         return { from: start, to: null };
      case "30d":
         start.setDate(start.getDate() - 30);
         return { from: start, to: null };
      default:
         return { from: null, to: null };
   }
}

export function formatDateTime(value) {
   if (!value) return "";
   const d = new Date(value);
   return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

// ---- Rândurile ca într-un jurnal de server ----------------------------------------------------

/** Nivelul rândului = culoarea lui: ok verde, info alb, warn galben, err roșu. */
export const LEVELS = {
   ok: { tag: "OK", label: "Reușit, a adăugat (bani, lecții, permisiuni)" },
   info: { tag: "INFO", label: "Acțiune obișnuită" },
   warn: { tag: "WARN", label: "Atenție: refuz, date greșite, ștergere" },
   err: { tag: "ERR", label: "Eroare de server sau bani scoși" },
};

// acțiuni care adaugă ceva (verde când reușesc)
const POSITIVE_ACTIONS = new Set([
   "reservations.create",
   "reservations.createForUser",
   "reservations.autoAssign",
   "reservations.autoAssignForUser",
   "reservations.restoreReservation",
   "exams.createStudentPermission",
   "exams.bulkCreateStudentPermissions",
   "practical-exam-slots.book",
   "practical-exam-slots.bookForStudent",
   "users.create",
   "users.createGuest",
   "auth.register",
   "groups.create",
]);

// acțiuni care scot sau anulează ceva (galben chiar când reușesc)
const WARN_ACTIONS = new Set([
   "users.remove",
   "reservations.delete",
   "reservations.deleteAllForUser",
   "reservations.cancelReservation",
   "practical-exam-slots.deleteReservation",
   "exams.markExamAsFailed",
   "exams.resetPractice",
]);

function amountOf(row) {
   const n = Number(row?.details?.result?.amountBani ?? row?.details?.body?.amountBani);
   return Number.isFinite(n) ? n : 0;
}

export function levelOf(row) {
   if (!row) return "info";
   if (!row.success) return row.statusCode >= 500 || row.statusCode === 499 ? "err" : "warn";
   if (row.action === "balance.adjust") return amountOf(row) < 0 ? "err" : "ok";
   if (WARN_ACTIONS.has(row.action)) return "warn";
   if (POSITIVE_ACTIONS.has(row.action)) return "ok";
   if (row.method === "DELETE") return "warn";
   return "info";
}

// numele câmpurilor din cereri, pentru om
const FIELD_LABELS = {
   startTime: "ora",
   instructorId: "instructor",
   userId: "elev",
   userIds: "elevi",
   studentId: "elev",
   sector: "sector",
   gearbox: "cutie",
   isConfirmed: "confirmată",
   isCancelled: "anulată",
   isFavorite: "favorită",
   isImportant: "importantă",
   color: "culoare",
   privateMessage: "notă privată",
   medical_documents: "doc. medicale",
   individual_work: "lucru individual",
   number_of_absences: "absențe",
   canBookPracticalExam: "poate programa ex. practic",
   groupId: "grupă",
   polygonDistrict: "poligon",
   firstName: "prenume",
   lastName: "nume",
   phone: "telefon",
   email: "email",
   password: "parolă",
   newPassword: "parolă nouă",
   role: "rol",
   reason: "motiv",
   maxAttempts: "încercări",
   validUntil: "valabil până la",
   dateTime: "ora",
   startDateTime: "de la",
   endDateTime: "până la",
   title: "titlu",
   content: "text",
   date: "data",
   status: "status",
   seatNumber: "loc",
   slotId: "slot",
   carId: "mașină",
   plateNumber: "număr",
   name: "nume",
   instructorType: "tip",
   carType: "cutie",
};

const ISO_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;

/** "2026-10-20T08:30:00.000Z" -> "20.10 11:30" (ora locală); anul doar dacă nu e anul curent. */
export function shortDateTime(value, now = new Date()) {
   const d = new Date(value);
   if (Number.isNaN(d.getTime())) return String(value);
   const year = d.getFullYear() !== now.getFullYear() ? `.${d.getFullYear()}` : "";
   return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}${year} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function nameOf(names, kind, id) {
   const n = names?.[kind]?.[id] ?? names?.[kind]?.[String(id)];
   return n ? n : `#${id}`;
}

/** O valoare din cerere, pentru om: da/nu, ore locale, nume în loc de id-uri, „(ascuns)” pentru parole. */
export function formatValue(key, value, names) {
   if (value === null || value === undefined || value === "") return "—";
   if (typeof value === "boolean") return value ? "da" : "nu";
   if (value === "[ascuns]") return "(ascuns)";
   if (key === "instructorId") return nameOf(names, "instructors", value);
   if (key === "userId" || key === "studentId") return nameOf(names, "users", value);
   if (key === "amountBani" || key === "balanceAfterBani" || key === "balanceBani") return formatLei(value);
   if (key === "gearbox" || key === "carType") return String(value).toLowerCase().startsWith("a") ? "automată" : "manuală";
   if (typeof value === "string" && ISO_RE.test(value)) return shortDateTime(value);
   if (Array.isArray(value)) return `${value.length} buc.`;
   if (typeof value === "object") return "…";
   const s = String(value);
   return s.length > 60 ? `${s.slice(0, 57)}…` : s;
}

function fieldList(obj, names, skip = []) {
   if (!obj || typeof obj !== "object") return [];
   return Object.entries(obj)
      .filter(([k, v]) => !skip.includes(k) && v !== undefined && (typeof v !== "object" || v === null || Array.isArray(v)))
      .slice(0, 8)
      .map(([k, v]) => `${FIELD_LABELS[k] || k} ${formatValue(k, v, names)}`);
}

function lessonChangeList(changes, names) {
   if (!changes) return [];
   return Object.entries(changes).map(([field, ch]) => {
      const label = FIELD_LABELS[field] || field;
      if (ch?.changed) return `${label} modificată`;
      return `${label} ${formatValue(field, ch?.from, names)} → ${formatValue(field, ch?.to, names)}`;
   });
}

function lessonList(result, names) {
   const items = Array.isArray(result?.items) ? result.items : result?.startTime ? [result] : [];
   const count = result?.count ?? items.length;
   if (!items.length) return count ? [`${count} lecții`] : [];
   const times = items.slice(0, 5).map((x) => shortDateTime(x.startTime));
   const more = count > times.length ? ` și încă ${count - times.length}` : "";
   const instructors = [...new Set(items.map((x) => x.instructorId).filter(Boolean))];
   const parts = [`${count === 1 ? "1 lecție" : `${count} lecții`}: ${times.join(", ")}${more}`];
   if (instructors.length === 1) parts.push(`instructor ${nameOf(names, "instructors", instructors[0])}`);
   if (items[0]?.sector) parts.push(items[0].sector);
   return parts;
}

/** Ce s-a făcut, pentru titlul rândului; la balanță — după tip și semn („A alimentat balanța”). */
export function rowTitle(row) {
   if (row?.action === "balance.adjust") {
      const type = row.details?.result?.type ?? row.details?.body?.type;
      if (type === "TOPUP_MANUAL") return "A alimentat balanța";
      if (type === "CORRECTION") return amountOf(row) < 0 ? "A scăzut din balanță (corectare)" : "A adăugat în balanță (corectare)";
   }
   return actionLabel(row?.action);
}

/**
 * Textul rândului după acțiune: ce s-a făcut concret (sume, ore, ce s-a schimbat), apoi motivul erorii.
 * names = { users: {id: nume}, instructors: {id: nume} } din răspunsul serverului.
 */
export function describeRow(row, names) {
   if (!row) return "";
   const d = row.details || {};
   const body = d.body && !d.body.truncated ? d.body : null;
   const result = d.result && !d.result.truncated ? d.result : null;
   const parts = [];

   if (row.action === "balance.adjust") {
      const amount = amountOf(row);
      const type = result?.type ?? body?.type;
      if (amount) parts.push(`${amount > 0 ? "+" : ""}${formatLei(amount)}${type === "TOPUP_CARD" ? " (card)" : ""}`);
      if (result?.balanceAfterBani !== undefined) parts.push(`sold după ${formatLei(result.balanceAfterBani)}`);
      const reason = result?.reason ?? body?.reason;
      if (reason) parts.push(`motiv „${reason}”`);
   } else if (row.category === "auth" || row.action?.startsWith("auth.")) {
      if (d.email) parts.push(d.email);
   } else if (row.action === "access.denied") {
      parts.push(`${row.method} ${row.route}`);
   } else if (row.entityType === "reservations") {
      const lesson = row.lesson;
      const multi = /\.(create|createForUser|autoAssign|autoAssignForUser)$/.test(row.action || "");
      if (multi) parts.push(...lessonList(result, names));
      else if (row.action === "reservations.deleteAllForUser") {
         if (result?.count !== undefined) parts.push(`${result.count} lecții`);
      } else {
         const when = lesson?.startTime || result?.startTime;
         const who = lesson?.instructorId || result?.instructorId;
         parts.push(`lecția #${row.entityId}${when ? ` din ${shortDateTime(when)}` : ""}${who ? `, instructor ${nameOf(names, "instructors", who)}` : ""}`);
         const changes = lessonChangeList(lesson?.changes, names);
         if (changes.length) parts.push(...changes);
         else if (row.action === "reservations.update" && body) parts.push(...fieldList(body, names, ["privateMessage"]));
      }
   } else if (row.action === "instructors.addBlackouts" && Array.isArray(body?.blackouts)) {
      const list = body.blackouts;
      const who = [...new Set(list.map((b) => b?.instructorId).filter(Boolean))];
      if (who.length === 1) parts.push(`instructor ${nameOf(names, "instructors", who[0])}`);
      const times = list.slice(0, 5).map((b) => (typeof b === "object" && b?.dateTime ? shortDateTime(b.dateTime) : "?"));
      parts.push(`${list.length === 1 ? "1 oră" : `${list.length} ore`}: ${times.join(", ")}${list.length > 5 ? ` și încă ${list.length - 5}` : ""}`);
   } else {
      const fields = fieldList(body, names);
      if (fields.length) parts.push(...fields);
      else if (result) parts.push(...fieldList(result, names, ["id"]));
   }

   if (d.error) parts.push(`eroare: ${d.error}`);
   else if (!row.success && row.statusCode) parts.push(row.statusCode === 499 ? "conexiunea s-a întrerupt" : `cod ${row.statusCode}`);
   return parts.filter(Boolean).join(" · ");
}
